import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Handover } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-home-content-rejected-team',
  templateUrl: './home-content-rejected-team.component.html',
  styleUrls: ['./home-content-rejected-team.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentRejectedTeamComponent implements OnInit {
  @Input() handoversRejectedTeam: Handover[] | undefined;
  @Input() totalHandoversRejectedTeam: number | undefined;
  @Input() searchRejectedTeam: string | undefined;
  @Output() handoversRejectedTeamWithFilter = new EventEmitter<string>();
  @Output() reloadRejectedTeam = new EventEmitter<boolean>();
  @Output() eventShowRejectedPersonal = new EventEmitter<boolean>();

  destinationLabel = 'Hacia';
  textSearch = '';

  constructor() {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    // Agrego esta linea para que Husky deje hacer commit y push.
    this.textSearch = this.searchRejectedTeam ? this.searchRejectedTeam : '';
  }

  eventReload(reload: boolean) {
    this.reloadRejectedTeam.emit(true);
  }
  showRejectedPersonal() {
    this.eventShowRejectedPersonal.emit(true);
  }

  getHandoversHomeRejectedTeamWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversRejectedTeamWithFilter.emit(searchText);
  }
}
